import Link from 'next/link';
import { ReactNode } from 'react';

import ArtistListItem, {
  ArtistListItemProps,
} from '@/components/Artist/ArtistListItem';
import useViewport from '@/hooks/useViewport';

export type ArtistListProps = {
  artists: ArtistListItemProps[];
  children?: ReactNode;
};

const MobileArtistList = (props: ArtistListProps) => {
  const { artists, children } = props;

  if (artists.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-[24px]">
        <p className="text-h4 font-bold text-gray-300">Line up</p>
        {artists.map((artist) => (
          <Link href={`/artists/${artist.id}`} key={artist.id}>
            <a>
              <ArtistListItem {...artist}></ArtistListItem>
            </a>
          </Link>
        ))}
      </div>
      {children}
    </>
  );
};

const TabletArtistList = (props: ArtistListProps) => {
  const { artists, children } = props;

  if (artists.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-[40px]">
        <p className="text-h1 font-bold text-gray-500">Line up</p>
        {artists.map((artist) => (
          <Link href={`/artists/${artist.id}`} key={artist.id}>
            <a>
              <ArtistListItem {...artist}></ArtistListItem>
            </a>
          </Link>
        ))}
      </div>
      {children}
    </>
  );
};

const DesktopArtistList = (props: ArtistListProps) => {
  const { artists, children } = props;

  if (artists.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-[40px]">
        <p className="text-h1 font-bold text-gray-500">Line up</p>
        {artists.map((artist) => (
          <Link href={`/artists/${artist.id}`} key={artist.id}>
            <a>
              <ArtistListItem {...artist}></ArtistListItem>
            </a>
          </Link>
        ))}
      </div>
      {children}
    </>
  );
};

const ArtistList = (props: ArtistListProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile`) {
    return <MobileArtistList {...props} />;
  }
  if (viewport == `tablet`) {
    return <TabletArtistList {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopArtistList {...props} />;
  }

  return null;
};

export default ArtistList;
